import { useMutation } from 'react-query';

import axiosInstance from '@server/axiosInstance';
import { adminRequestHitringGraphicsRoute } from '../api/constant';
import { Dispatch, SetStateAction } from 'react';
import { errorMessage } from '@features/applications';

type useAdminRequestHiringGraphicProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useAdminRequestHiringGraphic = ({
  setAlertText = () => { },
}: useAdminRequestHiringGraphicProps) => {

  const {
    mutate: requestHiringGraphic,
    isLoading: isRequestHiringGraphicLoading,
  } = useMutation({
    mutationFn: (variables: {
      user_id: number;
      is_enterprise?: number
    }) =>
      axiosInstance.post(adminRequestHitringGraphicsRoute, variables).then((res) => res.data),
    onError: () => {
      setAlertText(errorMessage);
    },
  });

  return {
    requestHiringGraphic,
    isRequestHiringGraphicLoading,
  };
};
